.imageWrap {
  width: 40%;
  margin: 0 auto;
}

@media (min-width: 75em) {
  .imageWrap {
    width: 80%;
  }
}
